export default {
  ambitusDetector: {
    back: 'Retour',
    introduction: 'Introduction',
    determineRange: 'Déterminons votre tessiture',
    testDescription: 'Nous allons tester ensemble la tessiture de votre voix ce sera rapide et sans douleur ! 😉',
    testInstructions: 'Le piano va vous jouer progressivement des notes de plus en plus graves, puis de plus en plus aiguës. Essayez de les chanter en même temps.',
    increaseVolumeTitle: 'Augmentez le son',
    increaseVolumeText: 'Cet exercice requiert que le son de votre appareil soit activé.',
    warmUpTitle: 'Pensez à vous échauffer',
    warmUpText: 'Pour être sûr d\'être dans les meilleures conditions, n\'hésitez pas à chauffer un peu votre voix avant de commencer l\'exercice.',
    takeTest: 'Faire le test',
    notInterested: 'Le chant ne m\'intéresse pas',
    startingNote: 'Note de départ',
    startingNoteCaption: 'Choix de la note de départ',
    findIdealNote: 'Trouvons la note idéale pour commencer le test !',
    areYou: 'Êtes vous...',
    genderInfo: 'Cette information nous permet de choisir la meilleure note de départ afin de maximiser la précision de ce test. Cette information ne sera pas conservée.',
    man: 'Un Homme',
    woman: 'Une Femme',
    other: 'Autre',
    noAnswer: 'ne pas répondre',
    lowMeasure: 'Mesure basse',
    lowMeasureCaption: 'Mesure de la note chantable la plus grave',
    findLowestNote: 'Trouvons votre note la plus grave',
    highMeasure: 'Mesure haute',
    highMeasureCaption: 'Mesure de la note chantable la plus aiguë',
    findHighestNote: 'Faisons la même chose pour trouver votre note la plus aiguë',
    validation: 'Validation',
    congratsMessage: 'Bravo, quelle voix ! Grâce à ce petit exercice, nous allons pouvoir adapter les morceaux de notre répertoire à votre voix.'
  },
  ambitusValidation: {
    rangeDescription: 'Voici l\'ensemble de votre tessiture, la plage de note que vous pouvez chanter.',
    tooBigWarning: 'Votre plage vocale fait plus de 3 octaves ce qui n\'est généralement pas possible.',
    tooBigAdvice: 'nous vous conseillons très fortement de <b>repasser le test</b> en faisant attention dans les zones notes limites (les notes les plus graves ou aigues).',
    noForcing: '<b>Vous ne devez pas trop forcer sur votre voix !</b>',
    veryBigWarning: 'Votre plage vocale semble très large, ce n\'est pas impossible mais assez rare !',
    veryBigAdvice: 'nous vous conseillons de <b>vérifier votre plage vocale</b> notamment <b>dans les zones limites</b> (les notes les plus graves ou aigues).',
    retakeTest: 'Repasser le test',
    loading: 'Chargement...',
    confirm: 'Confirmer',
    changeNote: 'Changer la note : ',
    low: 'basse',
    high: 'haute'
  },
  noteEvaluator: {
    start: 'Commencer',
    canSingQuestion: 'Arrivez-vous a chanter cette note naturellement ?',
    canSing: 'J\'arrive a la chanter',
    tooComplicated: 'Note Trop compliquée',
    foundNote: 'On a trouvé votre note la plus {direction} !',
    high: 'aiguë',
    low: 'grave',
    confirmAbility: 'Etes vous bien capable de chanter cette note ?',
    confirmChoice: 'Je confirme',
    restartStep: 'Recommencer cette étape',
    sureQuestion: 'Etes-vous sûr de votre choix ?',
    imSure: 'Je suis sûr de moi',
    restart: 'Je recommence'
  }
};